import axios from 'axios';
import { serviceUrl } from '../../App';

export const GetCloudProductionTracking = () => {
  return axios.get(process.env.REACT_APP_API_GLOBAL_URL + `+product-tracking`);
};
export const AddCloudProductionTracking = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.post(
    process.env.REACT_APP_API_GLOBAL_URL + `+product-tracking/create`,
    obj,
    { headers }
  );
};
export const UpdateCloudProductionTracking = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.post(
    process.env.REACT_APP_API_GLOBAL_URL + `+product-tracking/edit`,
    obj,
    { headers }
  );
};
export const DeleteCloudProductionTracking = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL + `+product-tracking/delete`,
    obj,
    { headers }
  );
};
